import { ref, watchEffect } from "vue";

const THEME_KEY = "ridey-theme";

export const isDark = ref(
  localStorage.getItem(THEME_KEY) === "dark" ||
    (!localStorage.getItem(THEME_KEY) &&
      window.matchMedia("(prefers-color-scheme: dark)").matches)
);

export const toggleTheme = () => {
  isDark.value = !isDark.value;
  localStorage.setItem(THEME_KEY, isDark.value ? "dark" : "light");
};

watchEffect(() => {
  if (isDark.value) {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
});
